import { render, staticRenderFns } from "./About.vue?vue&type=template&id=49fddede&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=49fddede&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fddede",
  null
  
)

export default component.exports